export const FETCH_COMMUNITY_CONFIG = 'FETCH_COMMUNITY_CONFIG'

export const UPDATE_OR_CREATE_CONFIG = 'UPDATE_OR_CREATE_CONFIG'
export const SELECT_PARTNER_CODE = 'SELECT_PARTNER_CODE'



// WEBPACK FOOTER //
// ./src/pages/newsbrief/constants.ts